import React from 'react';
import { string, number, bool, func } from 'prop-types';

import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';
import 'assets/svgs/doubleQuotes.svg';

import styles from './Testimonial.css';

const Testimonial = ({
  autoplay,
  carouselHandler,
  totalPages,
  currentPage,
  title,
  text,
  author,
  authorDesc
}) => (
  <div className={styles.testimonial}>
    <div className={styles.container}>
      <h5 className={styles.title}>{title}</h5>

      <svg className={styles.doubleQuotes}>
        <use xlinkHref="#doubleQuotes" />
      </svg>

      <p className={styles.text}>{text}</p>

      <p className={styles.author}>{author}</p>
      <p className={styles.authorDesc}>{authorDesc}</p>
      
      <div className={styles.carousel}>
        <CarouselPagination
          totalItems={totalPages}
          currentPage={currentPage}
          autoplay={autoplay}
          onPageChange={carouselHandler}
          dark
        />
      </div> 
    </div>
  </div>
);

Testimonial.propTypes = {
  autoplay: bool,
  totalPages: number,
  currentPage: number,
  title: string,
  text: string,
  carouselHandler: func,
  author: string,
  authorDesc: string
};

Testimonial.displayName = 'Testimonial';

export default Testimonial;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/TestimonialsBanner/Testimonial/Testimonial.js